import {
  AdresseDruck,
  GefahrenDruck,
  ProduktlinieDruck,
  VermietetesObjektDruck,
} from '@ps20/bff-models';
import {
  Gefahr,
  numberToGermanNumberFormattedString,
  Produkt,
  VermietetesModalObjekt,
  VermietetesObjekt,
  VermietetesObjektEnum,
} from '@ps20-frontend/frontend-models';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';

const AUSLAENDISCHE_ADRESSE_PLZ_RISIKOORT = '99999';
const AUSLAND = 'Ausland';
const AUSLAENDISCHE_ADRESSE_HAUSNUMMER = '1';

export function getProduktlinienDruck(produkt: Produkt): ProduktlinieDruck[] {
  return produkt.produktlinien.map(produktlinie => {
    return {
      langText: produktlinie.langtext,
      kurzText: produktlinie.kurztext,
      selected: produktlinie.selected,
      deactivated: produktlinie.deactivated,
      segmentierungsKennzeichen: produktlinie.segmentierungskennzeichen,
      preisverzeichnis: produktlinie.preisverzeichnis,
    };
  });
}

export function mapLinienpreis(produkt: Produkt): string {
  let linienpreis = null;

  if (produkt.produktlinien != null) {
    const bruttopreis = getSelectedProduktlinie(produkt).bruttopreis;
    linienpreis = numberToGermanNumberFormattedString(bruttopreis);
  }
  return linienpreis;
}

export function mapGefahren(produkt: Produkt): Array<GefahrenDruck> {
  return getSelectedProduktlinie(produkt).gefahren.map((gefahr: Gefahr) => {
    return {
      label: gefahr.label,
      taasTarifrisikoschluessel: gefahr.name,
      isSelected: gefahr.isSelected,
      plzFaktor: gefahr.plzFaktor,
      anzahlVorschaeden: gefahr.anzahlVorschaeden,
      deltafaktor: gefahr.deltafaktor,
    };
  });
}

export function mapVermieteteObjekte(
  vermieteteObjekte: VermietetesModalObjekt[] | VermietetesObjekt[],
): VermietetesObjektDruck[] {
  return vermieteteObjekte.map((item: VermietetesModalObjekt | VermietetesObjekt) => {
    const adresseDruck: AdresseDruck = {
      plz: item.auslaendischeAdresse ? AUSLAENDISCHE_ADRESSE_PLZ_RISIKOORT : item.plz,
      ort: item.auslaendischeAdresse ? AUSLAND : item.ort,
      strasse: item.auslaendischeAdresse ? AUSLAND : item.strasse,
      hausnummer: item.auslaendischeAdresse ? AUSLAENDISCHE_ADRESSE_HAUSNUMMER : item.hausnummer,
    };

    if (item.grundstueckBebaut === VermietetesObjektEnum.BEBAUT) {
      return {
        adresse: adresseDruck,
        grundstueckBebaut: true,
        wohneinheiten: item.wohneinheiten,
        bruttojahresmieteWohneinheiten: item.bruttojahresmieteWohneinheiten,
        gewerbeeinheiten: item.gewerbeeinheiten,
        bruttojahresmieteGewerbeeinheiten: item.bruttojahresmieteGewerbeeinheiten,
        stellplaetze: item.stellplaetze,
        bruttojahresmieteStellplaetze: item.bruttojahresmieteStellplaetze,
        deltafaktorWohnung: item.deltafaktorWohnung,
        plzFaktorWohnung: item.plzFaktorWohnung,
        deltafaktorGewerbe: item.deltafaktorGewerbe,
        plzFaktorGewerbe: item.plzFaktorGewerbe,
        deltafaktorGarage: item.deltafaktorGarage,
        plzFaktorGarage: item.plzFaktorGarage,
      };
    } else if (item.grundstueckBebaut === VermietetesObjektEnum.UNBEBAUT) {
      return {
        adresse: adresseDruck,
        grundstueckBebaut: false,
        grundstueckFlaeche: item.grundstueckFlaeche,
        flurstueckNummer: item.flurstueckNummer,
        deltafaktorUnbebaut: item.deltafaktorUnbebaut,
        plzFaktorUnbebaut: item.plzFaktorUnbebaut,
      };
    }
    return null;
  });
}
